import React, {Fragment} from "react";
import {Col, Container, Media} from "reactstrap";
import sad from "../../../../../assets/images/other-images/sad.png";
import './sessionNotFound.scss'

function SessionNotFound() {
  return (
    <Fragment>
      <div className="notFound">
        {/* <!-- error-404 start--> */}
        <div className="error-wrapper resetMinHeight">
          <Container>
            <Media body className="img-100" src={sad} alt="" />
            <Col md="8 offset-md-2">
              <p className="sub-content">
               La sessione che si sta cercando al momento non è disponibile
              </p>
            </Col>
          </Container>
        </div>
        {/* <!-- error-404 end--> */}
      </div>
    </Fragment>
  );
}

export default SessionNotFound
